$(function () {
  const $main   = $(".main_img img");
  const $thumbs = $(".thumb_img--item");
  const FADE_OUT = 200;  // ms
  const FADE_IN  = 220;  // ms

  $thumbs.on("click", function () {
    const $img = $(this).find("img");
    const src  = $img.attr("src");
    const alt  = $img.attr("alt") || "";

    if ($main.attr("src") === src) return; // 同じ画像なら何もしない

    // 先にプリロードしてから切替（チラつき防止）
    const tmp = new Image();
    tmp.onload = function () {
      // フェードアウト→差し替え→フェードイン
      $main.stop(true, true).fadeTo(FADE_OUT, 0, function () {
        $main.attr({ src: src, alt: alt })
             .stop(true, true).fadeTo(FADE_IN, 1);
      });
    };
    tmp.src = src;

    // サムネの選択状態
    $thumbs.removeClass("active");
    $(this).addClass("active");
  });
});

$(function(){
  $(".details_nutrients > li > p").on("click", function(){
    const $child = $(this).next(".child");
    $child.slideToggle(250);
    $(this).toggleClass("open");
  });
});

$(function(){
  function initSlider(){
    $(".category").each(function(){
      if($(window).width() < 768){   // スマホ幅のみ
        if(!$(this).hasClass("slick-initialized")){
          $(this).slick({
            slidesToShow: 1,
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 1500,
          });
        }
      } else {
        if($(this).hasClass("slick-initialized")){
          $(this).slick("unslick");
        }
      }
    });
  }

  initSlider();
  $(window).on("resize", initSlider);

  // .details_imgbox 単位で動くようにする
  $('.details_imgbox').on('click', '.sub_img--list_item img', function() {

    var $box     = $(this).closest('.details_imgbox'); // このボックス内だけ対象
    var $mainImg = $box.find('.main_img');
    var mainSrc  = $mainImg.attr('src'); // 今のメイン画像
    var subSrc   = $(this).attr('src');  // クリックしたサブ画像

    if (!subSrc || !$mainImg.length) {
      console.log('main_img が見つからない or subSrc なし');
      return;
    }

    // フェードしながらメイン画像を切り替え
    $mainImg.fadeOut(150, function() {
      $mainImg.attr('src', subSrc).fadeIn(150);
    });

    // メイン画像とサブ画像を入れ替え
    $(this).attr('src', mainSrc);
  });
});

